import { render } from "./PortalFooter.vue?vue&type=template&id=918b1312&scoped=true"
import script from "./PortalFooter.vue?vue&type=script&lang=js"
export * from "./PortalFooter.vue?vue&type=script&lang=js"

import "./PortalFooter.vue?vue&type=style&index=0&id=918b1312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918b1312"]])

export default __exports__